import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react'
import swal from 'sweetalert';
import LoadingBar from "react-top-loading-bar";
import { useIsOnline } from 'react-use-is-online';
import { useDeleteRegionMutation, useEditRegionMutation, useGetRegionByIdQuery } from '../../Features/regionSlice';

function EditRegionView() {
    const navigate = useNavigate();
    const { region_id } = useParams();
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();

    const [errors, setErrors] = useState({
        name: '',
        description: '',
    })
    
    const [input, setInput] = useState({})
    
    const [editRegion,isLoadingEditRegion] = useEditRegionMutation();
    const [deleteRegion,isLoadingDeleteRegion] = useDeleteRegionMutation();

    const {
        data: region,
        isLoading,
        isSuccess,
    } = useGetRegionByIdQuery(region_id);


    useEffect(()=>{
        if(isLoading){
            setProgress(80)
        }if(isSuccess){
            setProgress(100)
        }else{
            setProgress(100)
        }
        if(isSuccess && region.hasOwnProperty("data")){
            setInput(region.data)
        }
        return () =>{
        }
    },[region,editRegion,deleteRegion]);

    const handleChange = (e)=>{
        setInput({...input, [e.target.name]: e.target.value})
    }

    
    const handDeleteRegion = async(e,id)=>{
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        if(window.confirm("Are you sure you want to delete this region?")){
            try {
            setProgress(80)
            const resp = await deleteRegion(id).unwrap();
            if(resp.hasOwnProperty('success') == true){
                setProgress(100)
                return navigate(-1);
            }
        } catch (err) {
            setProgress(100)
            swal("Error",err.message,'error');
        }
        }
    }
    const handleSubmit = async(e)=>{
        e.preventDefault();
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        try {
            setProgress(80)
            const resp = await editRegion(input).unwrap()
            if(resp.hasOwnProperty('success') == true){
                setProgress(100)
                navigate(-1);
            }
        } catch (err) {
            setProgress(100)
            if(err.data.hasOwnProperty('errors') == true){
                setErrors({...errors, 
                    name: err.data.errors.name,
                    description: err.data.errors.description
                })
            }else if (err.data.hasOwnProperty('error') == true){
                setInput({...input, errorMassage: err.data.error})
            }
        }          
    }

    const back = ()=> {
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        navigate(-1)
    };

    return(   
        <div className="md:w-2/5 mb-12">
            <LoadingBar
                color="#14b8a6"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <div class="bg-white shadow-md rounded-md flex flex-col justify-center">
                <div class="p-3">
                    <form onSubmit={handleSubmit} autoComplete="off" >
                        <div class="divide-y divide-gray-200">
                            <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                            <div class="flex flex-col">
                                <div class="col-span-6 sm:col-span-3 p-2">
                                    <label for="name" class="block text-xs text-gray-500">Name</label>
                                    <input 
                                        class="mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm  border-b border-gray-300"
                                        type="text"
                                        name="name" 
                                        id="name" 
                                        value={input.name}
                                        onChange={handleChange}
                                    />
                                    <p className="block text-sm font-medium text-red-800 p-0 m-0">{errors.name}</p>
                                </div>
                            </div>
                            <div class="flex flex-col p-2">
                                <label for="description" class="block text-xs text-gray-500">Description</label>
                                <textarea 
                                    class="mt-1 p-2 h-20 text-gray-700 outline-none focus:border-green-500 block w-full sm:text-sm border rounded-md"
                                    type="text"
                                    placeholder='Role description...'
                                    name="description" 
                                    id="description" 
                                    value={input.description}
                                    onChange={handleChange}
                                />
                                <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.description}</p>
                            </div>
                            <div class="flex items-center p-2 justify-between space-x-3 w-full border-t  border-gray-200">
                                <div class="flex flex-col space-y-2 text-gray-400 flex-wrap w-2/3">
                                    <label class="text-gray-500 text-sm">Delete region</label>
                                    <div class="text-sm">You can delete this region permanently.</div>
                                </div>
                                <div class="flex justify-end text-sm">
                                    <div onClick={(e)=>handDeleteRegion(e, input.id)} className='px-x-2 text-green-500 font-bold uppercase cursor-pointer rounded-md'>Delete</div>
                                </div>
                            </div>
                            </div>
                            <div class="pt-4 flex items-end space-x-4">
                                <div onClick={back} class="flex cursor-pointer hover:bg-gray-50 justify-center items-center w-full text-gray-900 px-4 py-3 rounded-md focus:outline-none">
                                    Cancel
                                </div>
                                <button type='submit' class="bg-green-500 flex justify-center items-center w-full text-white px-4 py-3 rounded-sm hover:shadow-md focus:outline-none">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        )

}

export default EditRegionView;
